import IconCheck from 'components/icons/icon-check';
import IconChevron from 'components/icons/icon-chevron';
import IconCity from 'components/icons/icon-city';
import IconInfo from 'components/icons/icon-info';
import IconInfoBlue from 'components/icons/icon-info-blue';
import IconMixed from 'components/icons/icon-mixed';
import IconMountain from 'components/icons/icon-mountain';
import IconPencil from 'components/icons/icon-pencil';
import IconProfile from 'components/icons/icon-profile';
import IconRoad from 'components/icons/icon-road';
import IconTrash from 'components/icons/icon-trash';
import IconX from 'components/icons/icon-x';
import IconSpecialized from 'components/icons/icon-specialized';
import IconExternalLink from 'components/icons/icon-external-link';

export const Icons = {
  'check': IconCheck,
  'chevron': IconChevron,
  'commuter': IconCity,
  'info': IconInfo,
  'infoBlue': IconInfoBlue,
  'triathlon': IconMixed,
  'mountain': IconMountain,
  'pencil': IconPencil,
  'profile': IconProfile,
  'road': IconRoad,
  'specialized': IconSpecialized,
  'trash': IconTrash,
  'x': IconX,
  'externalLink': IconExternalLink,
};



// WEBPACK FOOTER //
// ./src/client/helpers/enums/icons.js